export default {
    "Unit:Shotgun:Load": {
        "volume": 1,
        "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/archive/chkchk.wav").default)
    },
    "Unit:PushGun:Shoot": {
        "volume": 1,
        "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/PUSH GUN.wav").default),
    },
    "Unit:PullGun:Shoot": {
        "volume": 1,
        "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/PULL GUN.wav").default),
    },
    "Unit:Shotgun:Shoot": {
        "volume": 1,
        "type": "sequence",
        "audio": [
            new Audio(require("@frog/source/assets/audio/bomber-tactics/BURST GUN 1.wav").default),
            new Audio(require("@frog/source/assets/audio/bomber-tactics/BURST GUN 2.wav").default),
        ]
    },
    "Unit:Throw": {
        "volume": 1,
        "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/BOMB THROW.wav").default),
    },
    "Unit:Move": {
        "volume": 1,
        "type": "random",
        "audio": [
            new Audio(require("@frog/source/assets/audio/bomber-tactics/MOVEMENT BOUNCE 1.wav").default),
            new Audio(require("@frog/source/assets/audio/bomber-tactics/MOVEMENT BOUNCE 2.wav").default),
            new Audio(require("@frog/source/assets/audio/bomber-tactics/MOVEMENT BOUNCE 3.wav").default),
        ]
    },
    "Bomb:Explode": {
        "volume": 1,
        "type": "sequence",
        "audio": [
            new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 1.wav").default),
            new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 2.wav").default),
            new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 3.wav").default),
            new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 4.wav").default),
        ]
    },
    "Music:1": {
        "type": "march",
        "volume": 0.37,
        "audio": [
            new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN1.wav").default),
            new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN1 LOOP.wav").default),
        ],
        "killTrigger": "Music:2",
        "killTrigger2": "Music:3",
    },
    "Music:2": {
        "type": "march",
        "volume": 0.7,
        "audio": [
            new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN2.wav").default),
            new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN2 LOOP.wav").default),
        ],
        "killTrigger": "Music:1",
        "killTrigger2": "Music:3",
    },
    "Music:3": {
        "type": "march",
        "volume": 0.7,
        "audio": [
            new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN3.wav").default),
            new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN3 LOOP.wav").default),
        ],
        "killTrigger": "Music:2",
        "killTrigger2": "Music:1",
    },
    "Selection:Start": {
        "volume": 0.33,
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Select.wav").default),
        "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/SELECT UNIT.wav").default),
    },
    "Selection:Cancel": {
        "volume": 0.33,
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UnSelect.wav").default),
        "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/CANCEL.wav").default),
    },
    "Selection:Finish": {
        "volume": 0.85,
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/PerformAction.wav").default),
        "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/CONFIRM.wav").default),
    },
    "Selection:Move": {
        "volume": 0.33,
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Hover.wav").default),
        "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/CURSOR MOVEMENT.wav").default),
    },
    "EndTurn": {
        "volume": 0.85,
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CONFIRM (Generic).wav").default)
        "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/END TURN.wav").default),
    },
    "UndoAction": {
        "volume": 0.85,
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX TEXT WINDOW CLOSE 2.wav").default)
        // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UndoAction.wav").default)
        "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/UNDO.wav").default),
    },
    // "Unit:Death": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CANNOT CONFIRM.wav").default)
    // },
    "Unit:Death:Falling": {
        "volume": 1,
        "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Falling Off Map.wav").default)
    },
    // "Unit:Escape": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Escape Map Zipline.wav").default)
    // },
    // "Flipper:Swing": {
    //     "volume": 1,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Bo Staff Flip.wav").default)
    //     ]
    // },
    // "Pusher:Swing": {
    //     "volume": 1,
    //     "type": "sequence",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 1.wav").default),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 2.wav").default),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 3.wav").default),
    //     ]
    // },
    // "Robot:Swing": {
    //     "volume": 1,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Robot Sounds.wav").default)
    //     ]
    // },
    // "Puller:Throw": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Frisbee Throw.wav").default)
    // },
    // "Puller:Pull": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Frisbee Pull In.wav").default)
    // },
    // "Aoe-er:Shoot": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Fire.wav").default)
    // },
    // "Aoe-er:Explosion": {
    //     "volume": 1,
    //     "type": "sequence",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Explosion.wav").default),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Explosion.wav").default),
    //     ]
    // },
    // "Victory": {
    //     "volume": 1,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Victory Theme 1.wav").default)
    //     ],
    // },
    // "Victory:Final": {
    //     "volume": 1,
    //     "type": "march",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Victory Theme ENDGAME.wav").default),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Main Theme Full.wav").default),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Main Theme Loop.wav").default),
    //     ],
    //     "killTrigger": "Music:Final",
    // }
}
